import { render } from "./CatalougeMain.vue?vue&type=template&id=47fe8086"
import script from "./CatalougeMain.vue?vue&type=script&lang=js"
export * from "./CatalougeMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__